import { useI18n } from "@/i18n";

export default function Footer() {
  const { $t } = useI18n();
  return (
    <div className="h-16 text-sm flex justify-center items-center bg-review-page   text-review-text dark:bg-reviewDark-page  dark:text-reviewDark-text">
      <a
        target="_blabk"
        href="https://beian.miit.gov.cn"
        className="text-review-text/70 hover:text-review-heading dark:text-reviewDark-muted dark:hover:text-reviewDark-heading transition-colors"
      >
        {$t("晋ICP备2024042419号-1")}
      </a>
    </div>
  );
}
